module.exports={Earlier:"ANTERIORMENTE",New:"NOVO",NoAnnouncements:"Você não tem avisos"};